import React from 'react'
import { Table, TableBody, TableHead, TableRow } from '@material-ui/core'
import { get } from 'lodash'
import clsx from 'clsx'
import {useStyles, StyledTableCell, StyledTableRow } from '../../styles'

export default function ProjectedHeadCountReport(props) {

	const classes = useStyles()

	return (
		<div className={classes.reportTableContainer}>
			<Table id="ProjectedHeadCountReport" className={classes.reportTable} size="small">
				<TableHead>
					<TableRow>
						<StyledTableCell colSpan={2} className={classes.noBorder}></StyledTableCell>
						{
							props.groups.map(group =>
								<React.Fragment key={group}>
									<StyledTableCell colSpan={2} className={classes.bgWhite}>
										{props.groupsNames[group]}
									</StyledTableCell>
									<StyledTableCell colSpan={2} className={classes.bgWhite}>
										Current
									</StyledTableCell>
									<StyledTableCell colSpan={2} className={classes.bgWhite}>
										Growth
									</StyledTableCell>
									<StyledTableCell colSpan={2} className={classes.bgWhite}>
										Future
									</StyledTableCell>
									<StyledTableCell className={classes.noBorder}></StyledTableCell>
								</React.Fragment>
							)
						}
					</TableRow>
					<TableRow>
						<StyledTableCell className={clsx(classes.bgBlack, classes.noBorder)}>
							Global Grade
						</StyledTableCell>
						<StyledTableCell className={classes.noBorder}></StyledTableCell>
						{
							props.groups.map(group =>
								<React.Fragment key={group}>
									<StyledTableCell
										className={classes.bgBlueGrey}
									>
										{'Cat/Level'}
									</StyledTableCell>
									<StyledTableCell
										className={classes.bgBlueGrey}
									>
										{'Job title'}
									</StyledTableCell>
									<StyledTableCell className={classes.bgBlueGrey}>
										n
									</StyledTableCell>
									<StyledTableCell className={classes.bgBlueGrey}>
										%
									</StyledTableCell>
									<StyledTableCell className={classes.bgBlueGrey}>
										n
									</StyledTableCell>
									<StyledTableCell className={classes.bgBlueGrey}>
										%
									</StyledTableCell>
									<StyledTableCell className={classes.bgBlueGrey}>
										n
									</StyledTableCell>
									<StyledTableCell className={classes.bgBlueGrey}>
										%
									</StyledTableCell>
									<StyledTableCell className={classes.noBorder}>
									</StyledTableCell>
								</React.Fragment>
							)
						}
					</TableRow>
				</TableHead>
				<TableBody>
					{
						props.levelsData.map((levelData, i) => {
							return (
								<StyledTableRow key={i}>
									<StyledTableCell className={classes.bgBlack}>
										{i}
									</StyledTableCell>
									<StyledTableCell className={classes.noBorder}></StyledTableCell>
									{
										props.groups.map(group => {
											const groupLevelData = levelData[group]
											const level = get(groupLevelData, 'level', '')
											return (
												<React.Fragment key={`${i}${group}`}>
													<StyledTableCell className={level ? classes.bgBlack : classes.bgWhite}>
														{get(groupLevelData, 'level', '')}
													</StyledTableCell>
													<StyledTableCell align="left" className={clsx(classes.leftJustified, level ? classes.bgBlack : classes.bgWhite)}>
														{get(groupLevelData, 'title', '')}
													</StyledTableCell>
													<StyledTableCell className={level ? classes.bgLightBlue : classes.bgWhite}>
														{get(groupLevelData, 'current.n', '')}
													</StyledTableCell>
													<StyledTableCell className={level ? classes.bgLightBlue : classes.bgWhite}>
														{get(groupLevelData, 'current.percent', '')}
													</StyledTableCell>
													<StyledTableCell className={level ? classes.bgLightBlue : classes.bgWhite}>
														{get(groupLevelData, 'growth.n', '')}
													</StyledTableCell>
													<StyledTableCell className={level ? classes.bgLightBlue : classes.bgWhite}>
														{get(groupLevelData, 'growth.percent', '')}
													</StyledTableCell>
													<StyledTableCell className={level ? classes.bgLightBlue : classes.bgWhite}>
														{get(groupLevelData, 'future.n', '')}
													</StyledTableCell>
													<StyledTableCell className={level ? classes.bgLightBlue : classes.bgWhite}>
														{get(groupLevelData, 'future.percent', '')}
													</StyledTableCell>
													<StyledTableCell className={classes.bgWhite}>
													</StyledTableCell>
												</React.Fragment>
											)
										})
									}
								</StyledTableRow>
							)
						})
					}
					<StyledTableRow>
						<StyledTableCell className={classes.noBorder}></StyledTableCell>
					</StyledTableRow>
					<StyledTableRow>
						<StyledTableCell colSpan={1} className={classes.bgLightGreen}>Total {props.currentTotalN}</StyledTableCell>
						<StyledTableCell colSpan={1} className={classes.noBorder}></StyledTableCell>
						{
							props.groups.map(group =>
								<React.Fragment key={group}>
									<StyledTableCell className={classes.noBorder} colSpan={2}></StyledTableCell>
									<StyledTableCell className={classes.bgLightGreen}>
										{get(props.groupSummary[group], 'current.total', '')}
									</StyledTableCell>
									<StyledTableCell className={classes.bgLightGreen}>
										{get(props.groupSummary[group], 'current.percent', '')}
									</StyledTableCell>
									<StyledTableCell className={classes.bgLightGreen}>
										{get(props.groupSummary[group], 'growth.total', '')}
									</StyledTableCell>
									<StyledTableCell className={classes.bgLightGreen}>
										{get(props.groupSummary[group], 'growth.percent', '')}
									</StyledTableCell>
									<StyledTableCell className={classes.bgLightGreen}>
										{get(props.groupSummary[group], 'future.total', '')}
									</StyledTableCell>
									<StyledTableCell className={classes.bgLightGreen}>
										{get(props.groupSummary[group], 'future.percent', '')}
									</StyledTableCell>
									<StyledTableCell className={classes.noBorder}>
									</StyledTableCell>
								</React.Fragment>
							)
						}
					</StyledTableRow>
					<TableRow className={classes.footerLabelRow}>
						<StyledTableCell colSpan={2} className={classes.noBorder}></StyledTableCell>
						{
							props.groups.map(group =>
								<React.Fragment key={group}>
									<StyledTableCell colSpan={2} className={classes.noBorder}></StyledTableCell>
									<StyledTableCell colSpan={2} className={classes.footerLabelCell}>
										Current
									</StyledTableCell>
									<StyledTableCell colSpan={2} className={classes.footerLabelCell}>
										Growth
									</StyledTableCell>
									<StyledTableCell colSpan={2} className={classes.footerLabelCell}>
										Future
									</StyledTableCell>
									<StyledTableCell className={classes.noBorder}></StyledTableCell>
								</React.Fragment>
							)
						}
					</TableRow>
				</TableBody>
			</Table>
		</div>
	)
}

